import { RequestError } from '@zurich-framework/core/errors';
import { postGenericDocuments, } from '@zurich/api/document';
import { useFetchApi, useTranslation } from '@zurich/common/hooks';
export function useUploadFiles() {
    const { t } = useTranslation();
    const { fetchApi } = useFetchApi();
    const handleFetch = async ({ key, keyType, docType, docSubType, keys, info, files, }) => {
        const formData = new FormData();
        formData.set('docSubType', docSubType);
        formData.set('docType', docType);
        if (info)
            formData.set('info', info);
        if (keyType) {
            formData.set('keyType', keyType);
        }
        // All properties in keys list must be set separately.
        if (keys) {
            keys.forEach((keyItem, index) => {
                Object.entries(keyItem).forEach(([key, value]) => {
                    formData.set(`keys[${index}].${key}`, value);
                });
            });
        }
        // if the keys property exists, then key is automatically set by the document
        if (!keys) {
            formData.set('key', key);
        }
        files.forEach((item) => {
            formData.append('files', item.file);
        });
        const ret = await fetchApi(postGenericDocuments, {
            body: formData,
        }, {
            errorText: (error) => {
                const parentError = error.findParent(RequestError);
                if (parentError?.code === 'ERR_FILE_UPLOAD_INVALID' ||
                    parentError?.code === 'ERR_DOCUMENT_VALIDATION') {
                    return t('document.errors.uploadDocumentInvalid');
                }
                return t('document.errors.uploadDocument');
            },
        });
        if (!ret) {
            throw new Error(t('document.errors.uploadDocument'));
        }
        return ret;
    };
    return handleFetch;
}
